module.exports = __webpack_public_path__ + "img/btn_stroke_off.05fa1cc8.svg";